import {createActionGroup, props} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../../error/error-handling/product-management-error';
import {ProductQueryParams} from '../../../models';
import {Bundle, PagedApiResponse} from '../../../models/clare';

export const BundleListActions = createActionGroup({
  source: 'Bundle List',
  events: {
    'Toggle Bundle Active Status': props<{productId: string; active: boolean}>(),
    'Toggle Bundle Active Status Success': props<{bundle: Bundle}>(),
    'Toggle Bundle Active Status Failure': props<{error: ProductManagementErrorInterface}>(),
    'Load Bundles': props<{queryParams: ProductQueryParams}>(),
    'Load Bundles Success': props<{bundles: PagedApiResponse<Bundle>}>(),
    'Load Bundles Failure': props<{error: ProductManagementErrorInterface}>(),
  },
});
